module.exports = __webpack_public_path__ + "img/laying-parquet.70d11492.svg";